import { ReactComponent as LogoComplete } from '@public/logos/logo-ausha-pro.svg';

const AushaProLogo = (props) => {
    return <LogoComplete {...props} />;
};

export default AushaProLogo;
